/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability for widgets that support action to have a buttonGroup
 * <br><br>

 *
 * @module MW/toolstrip/mixins/property/ButtonGroupMixin
 *
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare"
], function(declare){
    return declare(null, {
        _shouldUncheckWidget: function(widget) {
            return (widget.get("buttonGroup") === this.get("buttonGroup") && widget !== this && widget.get("checked") && (!widget.get("actionId") || (widget.get("actionId") !== this.get("actionId"))));
        }
    });

});